import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { appendBEMModifierOnCondition } from '@deliveryhero/armor-system';
import { useDatePickerDaySelectorCalendar } from './useDatePickerDaySelectorCalendar';
import { DATE_PICKER_DAY_SELECTOR_WEEK_DAYS } from '../constants';
import { useDatePickerDaySelectorSelection } from './useDatePickerDaySelectorSelection';
export var useDatePickerDaySelector = function useDatePickerDaySelector(props, ref) {
  var displayedDateVector = props.displayedDateVector,
    currentDateVector = props.currentDateVector,
    dirtyInternalValueVector = props.dirtyInternalValueVector,
    dayButtonProps = props.dayButtonProps,
    selectionStartCandidate = props.selectionStartCandidate,
    selectionEndCandidate = props.selectionEndCandidate,
    isDateAllowed = props.isDateAllowed,
    isDateFree = props.isDateFree;
  var calendar = useDatePickerDaySelectorCalendar(displayedDateVector, currentDateVector);
  var calendarWithSelection = useDatePickerDaySelectorSelection(calendar, dirtyInternalValueVector, selectionStartCandidate, selectionEndCandidate, isDateAllowed, isDateFree);
  return {
    rootProps: _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }),
    getDayProps: function getDayProps(item, baseClassName) {
      var day = item.day,
        month = item.month,
        year = item.year,
        displayedMonth = item.displayedMonth,
        current = item.current,
        _item$buttonProps = item.buttonProps,
        selected = _item$buttonProps.selected,
        allowed = _item$buttonProps.allowed,
        free = _item$buttonProps.free,
        rightEnd = _item$buttonProps.rightEnd,
        leftEnd = _item$buttonProps.leftEnd;
      return _objectSpread(_objectSpread({}, dayButtonProps), {}, {
        className: "".concat(baseClassName, " ").concat(appendBEMModifierOnCondition(baseClassName, 'displayedMonth', displayedMonth), " ").concat(appendBEMModifierOnCondition(baseClassName, 'selectedLeftEnd', leftEnd), " ").concat(appendBEMModifierOnCondition(baseClassName, 'selectedRightEnd', rightEnd), " ").concat(appendBEMModifierOnCondition(baseClassName, 'selectedMiddle', !rightEnd && !leftEnd && selected), " ").concat(appendBEMModifierOnCondition(baseClassName, 'allowed', allowed), " ").concat(appendBEMModifierOnCondition(baseClassName, 'current', current)),
        'data-day': day,
        'data-month': month,
        'data-year': year,
        'data-displayed-month': displayedMonth ? '1' : '0',
        'data-allowed': allowed ? '1' : '0',
        'data-free': free ? '1' : '0'
      });
    },
    weekDays: DATE_PICKER_DAY_SELECTOR_WEEK_DAYS,
    dayMatrix: calendarWithSelection
  };
};